import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: 24,
  },
  textCenter: {
    textAlign: 'center',
  },
  inputWrapper: {
    '&:nth-child(n+2)': {
      marginTop: '24px',
    },
  },
  greyText: {
    color: theme.palette.text.disabled,
  },
  submitButton: {
    width: '100%',
    margin: '16px 0 24px',
  },
  blueText: {
    color: theme.palette.primary.dark,
    fontWeight: 700,
  },
  checkboxIcon: {},
  checkboxIconActive: {},
  mailingCheckbox: {
    marginTop: 40,
    '&>span.Mui-checked + p': {
      fontWeight: 300,
      color: theme.palette.text.primary,
    },
    '&>span + p': {
      color: theme.palette.info.main,
    },
    '& .MuiIconButton-label>span': {
      borderWidth: 1,
      borderColor: theme.palette.info.light,
    },
  },
  terms: { marginBottom: 24 },
}));

export default useStyles;
